/**
 * Public API for Marketplace
 * This is the public API for the Marketplace service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface VideoBitratesInner { 
    /**
     * The URL of the video
     */
    url?: string;
    /**
     * The bitrate of the video
     */
    bitrate?: number;
    /**
     * Codec+options name
     */
    codec?: string;
}

